import { createSlice, current } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "battleGameAnalytics",
  initialState: {
    attempts: {},
    dailyProgression: {},
    dailyProgressionLoading: false,
    funnel: {},
    funnelLoading: false,
    bgMissionStats: [],
    bgMissionStatsLoading: false,
    bgMissionDailyProgressStats: {},
    bgMissionDailyProgressStatsLoading: false,
  },
  reducers: {
    attemptsRequested: (misc, action) => {
      misc.loading = true;
    },
    attemptsReceived: (misc, action) => {
      misc.attempts = action.payload.data;
      misc.lastFetch = Date.now();
      misc.loading = false;
    },
    attemptsRequestFailed: (misc, action) => {
      misc.loading = false;
    },
    dailyProgressionRequested: (misc, action) => {
      misc.dailyProgressionLoading = true;
    },
    dailyProgressionReceived: (misc, action) => {
      misc.dailyProgression = action.payload.data;
      misc.lastFetch = Date.now();
      misc.dailyProgressionLoading = false;
    },
    dailyProgressionRequestFailed: (misc, action) => {
      misc.dailyProgressionLoading = false;
    },
    funnelRequested: (misc, action) => {
      misc.funnelLoading = true;
    },
    funnelReceived: (misc, action) => {
      misc.funnel = action.payload.data;
      misc.lastFetch = Date.now();
      misc.funnelLoading = false;
    },
    funnelRequestFailed: (misc, action) => {
      misc.funnelLoading = false;
    },
    bgMissionStatsRequested: (misc, action) => {
      misc.bgMissionStatsLoading = true;
    },
    bgMissionStatsReceived: (misc, action) => {
      misc.bgMissionStats = action.payload.data;
      misc.bgMissionStatsLoading = false;
    },
    bgMissionStatsRequestFailed: (misc, action) => {
      misc.bgMissionStatsLoading = false;
    },
    bgMissionDailyProgressStatsRequested: (misc, action) => {
      misc.bgMissionDailyProgressStatsLoading = true;
    },
    bgMissionDailyProgressStatsReceived: (misc, action) => {
      misc.bgMissionDailyProgressStats = action.payload.data;
      misc.bgMissionDailyProgressStatsLoading = false;
    },
    bgMissionDailyProgressStatsRequestFailed: (misc, action) => {
      misc.bgMissionDailyProgressStatsLoading = false;
    },
  },
});

export const {
  attemptsRequested,
  attemptsReceived,
  attemptsRequestFailed,
  dailyProgressionRequested,
  dailyProgressionReceived,
  dailyProgressionRequestFailed,
  funnelRequested,
  funnelReceived,
  funnelRequestFailed,
  bgMissionStatsRequested,
  bgMissionStatsReceived,
  bgMissionStatsRequestFailed,
  bgMissionDailyProgressStatsRequested,
  bgMissionDailyProgressStatsReceived,
  bgMissionDailyProgressStatsRequestFailed,
} = slice.actions;
export default slice.reducer;

// Action Creators
const gameUrl = "battle/battleGame/stats/";

export const loadTotalAttempts = (id, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: gameUrl + "attempts/" + id,
      onStart: attemptsRequested.type,
      onSuccess: attemptsReceived.type,
      onError: attemptsRequestFailed.type,
      callback,
    }),
  );
};
export const loadDailyProgression = (id, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: gameUrl + "dailyProgression/" + id,
      onStart: dailyProgressionRequested.type,
      onSuccess: dailyProgressionReceived.type,
      onError: dailyProgressionRequestFailed.type,
      callback,
    }),
  );
};
export const loadFunnel = (id, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: gameUrl + "funnel/" + id,
      onStart: funnelRequested.type,
      onSuccess: funnelReceived.type,
      onError: funnelRequestFailed.type,
      callback,
    }),
  );
};
export const loadMissionStats = (id, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: gameUrl + "bgGameMissions/" + id,
      onStart: bgMissionStatsRequested.type,
      onSuccess: bgMissionStatsReceived.type,
      onError: bgMissionStatsRequestFailed.type,
      callback,
    }),
  );
};
export const loadMissionDailyProgressionStats = (id, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: gameUrl + "dailyMissionProgression/" + id,
      onStart: bgMissionDailyProgressStatsRequested.type,
      onSuccess: bgMissionDailyProgressStatsReceived.type,
      onError: bgMissionDailyProgressStatsRequestFailed.type,
      callback,
    }),
  );
};
export const getBattleGameAnalytics = createSelector(
  (state) => state.entities.battleGameAnalytics,
  (battleGameAnalytics) => battleGameAnalytics,
);
